// Shared schema.org entities. Every page's JSON-LD graph (components/SEO.jsx)
// includes websiteSchema and organizationSchema; other entities point to them by @id.
import { SITE, canonicalFor } from "../lib/site";

export const ORG_ID = `${SITE}/#organization`;
export const WEBSITE_ID = `${SITE}/#website`;
export const FOUNDER_ID = `${SITE}/about/#somil-grover`;

export const AREA_SERVED = [
  { "@type": "Country", name: "India" },
  { "@type": "Country", name: "United States" },
  { "@type": "Country", name: "United Arab Emirates" },
];

export const websiteSchema = {
  "@type": "WebSite",
  "@id": WEBSITE_ID,
  url: `${SITE}/`,
  name: "Grotech Web",
  inLanguage: "en",
  publisher: { "@id": ORG_ID },
};

export const founderSchema = {
  "@type": "Person",
  "@id": FOUNDER_ID,
  name: "Somil Grover",
  jobTitle: "Founder, Grotech Web",
  url: `${SITE}/about/`,
  worksFor: { "@id": ORG_ID },
  knowsAbout: ["Website development", "Search engine optimization", "Shopify development", "Conversion rate optimization", "AI chatbots"],
};

export const organizationSchema = {
  "@type": "ProfessionalService",
  "@id": ORG_ID,
  name: "Grotech Web",
  alternateName: "GroTech Web",
  url: `${SITE}/`,
  logo: { "@type": "ImageObject", url: `${SITE}/logo-512.png`, width: 512, height: 512 },
  image: `${SITE}/og-image.png`,
  description:
    "Grotech Web is a website development and SEO company that builds fast, SEO-ready, lead-generating websites, Shopify stores and AI chatbots for businesses in India, the USA and the UAE (Dubai), working remotely.",
  telephone: "+91-98217-71460",
  priceRange: "₹25,000+ / $999+ / AED 3,499+",
  areaServed: AREA_SERVED,
  founder: founderSchema,
  knowsLanguage: ["en", "hi"],
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+91-98217-71460",
      contactType: "sales",
      contactOption: "WhatsApp",
      areaServed: ["IN", "US", "AE"],
      availableLanguage: ["English", "Hindi"],
    },
  ],
  knowsAbout: [
    "Website development",
    "Business website design",
    "Lead generation websites",
    "Search engine optimization",
    "Local SEO",
    "Shopify website development",
    "E-commerce website development",
    "AI chatbot development",
    "AI business automation",
  ],
  makesOffer: [
    { "@type": "Offer", name: "Business website", priceSpecification: { "@type": "PriceSpecification", minPrice: 25000, priceCurrency: "INR" }, areaServed: { "@type": "Country", name: "India" } },
    { "@type": "Offer", name: "Business website", priceSpecification: { "@type": "PriceSpecification", minPrice: 999, priceCurrency: "USD" }, areaServed: { "@type": "Country", name: "United States" } },
    { "@type": "Offer", name: "Business website", priceSpecification: { "@type": "PriceSpecification", minPrice: 3499, priceCurrency: "AED" }, areaServed: { "@type": "Country", name: "United Arab Emirates" } },
  ],
};

// A Service entity provided by the organisation (used on service, market and location pages).
export const serviceSchema = ({ name, description, path, serviceType, areaServed = AREA_SERVED }) => ({
  "@type": "Service",
  "@id": `${canonicalFor(path)}#service`,
  name,
  description,
  url: canonicalFor(path),
  serviceType: serviceType || name,
  provider: { "@id": ORG_ID },
  areaServed,
});

export const faqSchema = (faqs) => ({
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
